// IndicesListWidget.tsx
import React from 'react';
import styled from 'styled-components';
import { INDICES_SLUG } from '@/src/common/enum';
import { CardWrapper, CustomWidgetHeader, DataTable } from './style';

interface IndicesListItem {
  name: string;
  price: number;
  priceChange: number;
  changePercent: number;
}

const IndicesWidget: React.FC<{ data: IndicesListItem[] }> = ({ data }) => (
  <CardWrapper>
    <div className="custom-widget">
      <CustomWidgetHeader>
        <h2>Indices</h2>
        <a href="/indices" className="links-btn">
          View All
        </a>
      </CustomWidgetHeader>
      <DataTable>
        <tbody>
          {data.map((item) => {
            const indexName = item.name;
            return (
              <tr key={item.name}>
                <td>
                  <a href={`/indices/${INDICES_SLUG[indexName]}`}>{item.name}</a>
                </td>
                <td>
                <p className="price-value">{item.price?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
                <p className={`${item.priceChange <= 0 ? 'negative' : ''}`}>
                    {item.priceChange?.toFixed(2)}<span>({item.changePercent?.toFixed(2)}%)</span>
                </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </DataTable>
    </div>
  </CardWrapper>
);

export default IndicesWidget;
